<template>
  <div class="container">
    <canvas id="canvas"></canvas>
    <div id="stats"></div>
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" version="1.1">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation=10 result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 60 -9"/>
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
const colorPalette = ['#44B4E6', '#72CE16', '#FF9F64', '#F2D328', '#B080FD', '#FC64F3'];
const width = 100;
const height = 100;
const origin = {
  x: width / 2,
  y: height / 2,
};
class Ball {
  constructor() {
    this.x = origin.x;
    this.y = origin.y;
    this.angle = Math.PI * 2 * Math.random();
    this.vx = (1.3 + Math.random() * 0.3) * Math.sin(this.angle);
    // this.vx = Math.cos(this.angle);
    // this.vy = Math.sin(this.angle);
    this.vy = (1.3 + Math.random() * 0.3) * Math.cos(this.angle);
    this.r = 4 + 3 * Math.random();
    this.color = colorPalette[Math.floor(Math.random() * colorPalette.length)];
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    this.r -= 0.01;
  }
}

export default {
  data() {
    return {
      canvas: null,
      context: '',
      width: 0,
      height: 0,
      origin: {},
      balls: [],
      count: 0,
      randomCount: 0,
    };
  },
  mounted() {
    this.canvas = document.querySelector('#canvas');
    this.context = this.canvas.getContext('2d');

    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.canvas.width = 100;
    this.canvas.height = 100;
    this.origin = {
      x: this.width / 2,
      y: this.height / 2,
    };
    window.addEventListener('resize', this.resize);
    this.loop();
  },
  destroyed() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    resize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.origin = {
        x: this.width / 2,
        y: this.height / 2,
      };
      Ball.x = this.origin.x;
      Ball.y = this.origin.y;
    },
    loop() {
      this.context.clearRect(0, 0, this.width, this.height);
      if (this.count === this.randomCount) {
        this.balls.push(new Ball());
        this.count = 0;
        this.randomCount = 1 + Math.floor(Math.random() * 5);
      }
      this.count += 1;
      for (let i = 0; i < this.balls.length; i++) {
        const b = this.balls[i];
        this.context.fillStyle = b.color;
        this.context.beginPath();
        this.context.arc(b.x, b.y, b.r, 0, Math.PI * 2, false);
        this.context.fill();
        b.update();
      }

      this.context.fillStyle = '#ffdd02';
      // this.context.fillStyle = '#0a0a0a';
      this.context.beginPath();
      this.context.arc(origin.x, origin.y, 15, 0, Math.PI * 2, false);
      this.context.fill();

      this.removeBall();
      requestAnimationFrame(this.loop);
    },
    removeBall() {
      for (let i = 0; i < this.balls.length; i++) {
        const b = this.balls[i];
        if (
          b.x + b.r < 0
          || b.x - b.r > this.width
          || b.y + b.r < 0
          || b.y - b.r > this.height
          || b.r <= 0
        ) {
          this.balls.splice(i, 1);
        }
      }
    },
  },
};
</script>

<style scoped>

#canvas{
  position: absolute;
  -webkit-filter: url("#goo");
  filter: url("#goo");
}

</style>
